import React, { useEffect, useState } from 'react'
import NeedHelp from '../../../Common/NeedHelp/NeedHelp';
import { Card, Button, Row, Col, Modal } from 'antd';
import './multistepform.scss'
import styled from 'styled-components';
import usecustomStyles from '../../../Common/customStyles';
import OtpVerification from '../../Components/FormSteps/OtpVerification';
import prevButton from '../../../../src/assets/images/prev-button.png'
import BusinessType from '../../Components/FormSteps/BusinessType';
import AadhaarVerification from '../../Components/FormSteps/AadhaarVerification';
import BusinessCategory from '../../Components/FormSteps/BusinessCategory';
import BusinessName from '../../Components/FormSteps/BusinessName';
import BusinessDescription from '../../Components/FormSteps/BusinessDescription';
import AboutBusiness from '../../Components/FormSteps/AboutBusiness';
import GstVerification from '../../Components/FormSteps/GstVerification'
import axios from 'axios'
// import { api } from '../../../helpers/api_helper';
import { useSelector, useDispatch } from 'react-redux';
import { api } from '../../../helpers/api_helper';
import { businessInfo } from '../../../slices/businessInfo/thunk';
import { Navigate, useNavigate } from 'react-router-dom';
import { setAuthData } from '../../../helpers/localstorage/setAuthData';
import { Spin } from 'antd/lib';
import { requestOtp } from '../../../slices/auth/login/thunk';
import { fetchData } from '../../../Services/FetchData';
import Log from '../../../Services/Log';
import { getLineHeight } from 'antd/es/theme/internal';
import { Popup_Toast } from '../../../constants/Popups_Toast';
import { API_ENDPOINTS } from '../../../constants/apiEndPoints';
const StyleWrapper = styled.div`
    background-color: ${({ theme }) => theme.token.authbgcolor};
`
const MultiStepFormData = React.createContext();
const customStyles = usecustomStyles();

const data = [
    {
        "title": "OTP Verification",
        "content": ""
    },
    {
        "title": "Choose Your Business Type ",
        "content": "Select the business type that best describes your business."
    },
    // {
    //     "businessTitle": "Verify your GSTIN",
    //     "businessContent": "Securely verify your business identity using GSTIN.",
    //     "freelancerTitle": "Verify your Identity",
    //     "freelancerContent": "Authenticate your identity securely using your PAN."
    // },
    {
        "title": "Choose Your Business Category",
        "content": "Select the category that best describes your business."
    },
    {
        "title": "What is the Name of Your Business?",
        "content": "This name will be visible to users on your listing. "
    },
    {
        "title": "Add a Description for Your Business",
        "content": "This will be visible to users on business page.  "
    },
    {
        "title": "Tell us more about your Business",
        "content": "These details will be visible to users on your listing. "
    },
]



const MultiStepForm = () => {
    const popupData = Popup_Toast?.MULTI_STEP_FORM?.BACK_ONBOARDING;
    let getGstDetailsFlag = true;
    const [gstDataModal, setGstDataModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [errorModal, setErrorModal] = useState({
        status: false,
        message: ""
    });
    const [unsavedProgressModal, setUnsavedProgressModal] = useState(false);
    const dispatch = useDispatch()
    const [passedCategoriesList, setPassedCategoriesList] = useState([]);
    const [passedCategoryListStatus, setPassedCategoryListStatus] = useState([])
    const [categorySelected, setCategorySelected] = useState();
    const info = useSelector((state) => state.BusinessInfoReducer);
    const [currentPageStatus, setCurrentPageStatus] = useState();
    const [gstResponseDetails, setGstResponseDetails] = useState({
        'loading': true,
        'address': '',
        'business_name': '',
        'status': ''
    })
    const [skipButtonVisible, setSkipButtonVisible] = useState(true);
    const [resetForm, setResetForm] = useState(false);
    const getCategories = ((categoriesList) => {
        setPassedCategoriesList(categoriesList)
    })
    const [resentOtpTriggered, setRecentOtpTriggered] = useState(false)

    useEffect(() => {
        if (passedCategoriesList && passedCategoriesList.length > 0) {
            setPassedCategoryListStatus(passedCategoriesList.map(el => ({
                _id: el._id,
                status: false
            })));
        }
    }, [passedCategoriesList])




    // const [formVerified, setFormVerified] = useState([true, true, true, true, true, true, true, true]);
    let [formVerified, setFormVerified] = useState([false, false, false, false, false, false, false]);
    const navigate = useNavigate();
    let [formData, setFormData] = useState({
        otp: "",
        registeredBusiness: "",
        panNumber: "",
        gstin: "",
        businessCategories: [],
        otherCategories: "",
        businessName: "",
        logoUrl: "",
        businessDescription: "",
        businessAddress: '',
        contactNumber: "",
        pincode: "",
        state: {
            "code": "KL",
            "label": "Kerala"
        }
    });

    // useEffect(() => {
    //     console.log('businessInfo', businessInfo)
    //     // setFormData((prev) => ({
    //     //     ...prev,
    //     //     businessCategories: passedCategoryListStatus,
    //     // }));
    // }, [businessInfo])
    const current = useSelector(state => state.Login)
    const [otpVerified, setOtpVerified] = useState(false)
    let businessInfoDetails = useSelector(state => state.BusinessInfoReducer)
    businessInfoDetails = businessInfoDetails.businessInfo
    const loginData = useSelector(state => state.Login)
    const [loginPageRedirection, setLoginPageRedirection] = useState(true);
    const selectedCategory = (category) => {
        setCategorySelected(category)
    }

    // const handleCancel = () => {
    //     setErrorModal(prev => ({
    //         ...prev,
    //         status: false,
    //         message: ''
    //     }));
    // }
    useEffect(() => {
        let address = info?.businessInfo?.old_business_address ? info?.businessInfo?.old_business_address : info?.businessInfo?.business_address;
        let name = info?.businessInfo?.old_business_name ? info?.businessInfo?.old_business_name : info?.businessInfo?.business_name;
        let type = info?.businessInfo?.business_type;
        let pageStatus = info?.businessInfo?.profile_completion;
        let logoUrl = info?.businessInfo?.old_business_logo?.original ? info?.businessInfo?.old_business_logo?.original : info?.businessInfo?.business_logo?.original;
        console.log('logoUrl', logoUrl)
        if (address) {
            setFormData((prev) => ({
                ...prev,
                businessAddress: address
            }));
        }
        if (name) {
            setFormData((prev) => ({
                ...prev,
                businessName: name
            }));
            // setFormVerified({
            //     ...formVerified,
            //     [formVerified[6]]: true
            //   });
        }


    }, [info]);


    const checkBusinessInfoDetails = () => {
        if (businessInfoDetails) {
            const missingKeys = [];
            // KEY SHOULD BE LIMITED : PAGE NAME SHOULD BE PROVIDED FROM BACKEND 
            if (!otpVerified) missingKeys.push('otpVerified');
            if (!businessInfoDetails.business_category) missingKeys.push('business_category');
            if (!businessInfoDetails.business_description) missingKeys.push('business_description');
            if (!businessInfoDetails.business_logo?.original) missingKeys.push('business_logo.original');
            if (!businessInfoDetails.business_logo?.thumbnail) missingKeys.push('business_logo.thumbnail');
            // if (!businessInfoDetails.business_logo?.verification_status) missingKeys.push('business_logo.verification_status');
            if (!businessInfoDetails.business_name) missingKeys.push('business_name');
            if (!businessInfoDetails.business_type) missingKeys.push('business_type');
            if (!businessInfoDetails.contact_name) missingKeys.push('contact_name');
            if (!businessInfoDetails.contact_number) missingKeys.push('contact_number');
            if (!businessInfoDetails.gst_in) missingKeys.push('gst_in');
            if (!businessInfoDetails.location) missingKeys.push('location');
            if (!businessInfoDetails.social_media_attributes) missingKeys.push('social_media_attributes');
            if (!businessInfoDetails.vendor_id) missingKeys.push('vendor_id');

            if (missingKeys.length === 0) {
                navigate('/dashboard');
            } else {
                console.log("Some keys are missing values: ", missingKeys);
            }
        }
    }

    const verifyOtp = async (otp) => {
        setLoading(true)
        try {
            const response = await api.create(`${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.AUTH.VERIFY_OTP}`, {
                phone: current.user.phoneNumber,
                country_code: '+91',
                // temporary
                // otp: otp
                otp: loginData?.user?.otp

            });
            if (response?.statusCode === 200) {
                setAuthData(response.response);
                setOtpVerified(true);
                setCurrentPageStatus(response?.response?.profile_completion)
                if (response?.response?.profile_completion === 5) {
                    navigate('/dashboard')
                }
                if (response?.response?.profile_completion !== 6) {
                    setPage(5)
                }
                setLoading(false)

            }
            else {
                setLoading(false)
                setErrorModal(prev => ({
                    ...prev,
                    status: true,
                    message: response?.data?.message
                }));
                // temporary
                // setPage(2);
            }
        } catch (err) {
            console.error('catch error is showing', err);
            setLoading(false)
            setErrorModal(prev => ({
                ...prev,
                status: true,
                message: err
            }));
            // temporary
            // setPage(2);
        }
    }
    useEffect(() => {

        let pageStatus = currentPageStatus + 1;
        if (currentPageStatus >= 2) {
            // navigate to the dashboard if onboarding flow is already completed
            // if (currentPageStatus === pageLength - 1) {
            //     navigate('/dashboard')
            // }
            if (currentPageStatus === pageLength - 1) {
                navigate('/dashboard')
            }
            setPage(pageStatus)
        }
        else {
            if (currentPageStatus === 0) {
                setPage(1)
            }
        }



    }, [currentPageStatus])


    const verifyGst = async (data) => {
        setLoading(true)
        try {
            const response = await api.create(`${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.AUTH.VALIDATE_GST}`, data);
            if (response?.statusCode === 200) {
                updateBusinessInfo({ gst_in: formData.gstin }, 3);
                setLoading(false)
                setGstDataModal(false)
            } else {
                setLoading(false)
                setErrorModal(prev => ({
                    ...prev,
                    status: true,
                    message: response?.message
                }));
            }
        } catch (err) {
            setLoading(false)
            setErrorModal(prev => ({
                ...prev,
                status: true,
                message: err
            }));
        }
    }
    const verifyAadhaar = async (id_number) => {
        setLoading(true)
        setPage(3)
        setLoading(false)
        // try {
        //     const response = await api.create('/dev/v1/validateGst', {
        //         id_number: id_number
        //     });
        //     console.log(response)
        //     if (response?.statusCode === 200) {
        //         updateBusinessInfo({ gst_in: formData.gstin }, 3);
        //         setLoading(false)
        //     } else {
        //         setLoading(false)
        //         setErrorModal(prev => ({
        //             ...prev,
        //             status: true,
        //             message: response?.message
        //         }));
        //     }
        // } catch (err) {
        //     setLoading(false)
        //     setErrorModal(prev => ({
        //         ...prev,
        //         status: true,
        //         message: err
        //     }));
        // }
    }

    const verifyPan = async (data) => {
        setLoading(true)
        try {
            const response = await api.create(`${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.AUTH.PAN_VERIFICATION}`, { "id_number": data });
            if (response?.statusCode === 200) {
                updateBusinessInfo({ panNumber: formData.panNumber }, 3);
                setLoading(false)
            } else {
                setLoading(false)
                setErrorModal(prev => ({
                    ...prev,
                    status: true,
                    message: response?.message
                }));
            }
        } catch (err) {
            setLoading(false)
            setErrorModal(prev => ({
                ...prev,
                status: true,
                message: err
            }));
        }
    }


    const updateBusinessInfo = async (info, page) => {
        try {
            setLoading(true)
            // console.log('info', info);
            const data = await api.create(`${API_ENDPOINTS.BUSINESS_INFO.UPDATE}`, info);
            if (data) {
                setLoading(false)
                dispatch(businessInfo())
                if (page) {
                    if (page > pageLength - 1) {
                        navigate('/dashboard')
                    }
                    else {
                        setPage(page)
                    }
                }
            }
        } catch (err) {
            setLoading(false)
            setErrorModal(prev => ({
                ...prev,
                status: true,
                message: err
            }));
        }
    }



    useEffect(() => {
        // console.log('formData',formData);
        if (localStorage.getItem('accessToken') && page !== 0) {
            dispatch(businessInfo())
            // setOtpVerified(true)
            // navigate('/dashboard')
        }
        if (page == 0) {

            // if (localStorage.getItem('accessToken')) {
            //     console.log('2................');
            // setPage(1)
            //      }
        }
    }, [otpVerified]);



    useEffect(() => {
        checkBusinessInfoDetails();
    }, [businessInfoDetails]);



    useEffect(() => {
        if (info && page >= 1) {
            setCurrentPageStatus(info?.businessInfo?.profile_completion)
        }
    }, [info, page])

    useEffect(() => {
        console.log('business', formData.registeredBusiness)
    }, [formData])



    let pageLength = data.length;
    const progress = 100 / pageLength;

    const resendFunctionality = async (clicked) => {
        setLoading(true)
        try {
            const response = await dispatch(requestOtp(current.user.phoneNumber)).unwrap();
            setLoading(false)
            setRecentOtpTriggered(true);
        } catch (error) {
            setLoading(false)
            alert(error.message || 'An error occurred while requesting OTP');
            setRecentOtpTriggered(false);
        }
    }


    let sessionBusinessType = sessionStorage.getItem('businessType')

    const FormData = () => {
        switch (page) {
            case 0:
                return <OtpVerification resendClick={resendFunctionality} resentOtpTriggered={resentOtpTriggered} />;
            case 1:
                return <BusinessType />;
            // case 2:
            //     if (formData.registeredBusiness) {
            //         return formData.registeredBusiness === "freelancer" ? (
            //             <AadhaarVerification />
            //         ) : formData.registeredBusiness === "business" ? (
            //             <GstVerification />
            //         ) : null;
            //     } else {
            //         return sessionBusinessType === "freelancer" ? (
            //             <AadhaarVerification />
            //         ) : sessionBusinessType === "business" ? (
            //             <GstVerification />
            //         ) : null;
            //     }
            case 2:
                return <BusinessCategory getCategories={getCategories} selectedCategory={selectedCategory} />;
            case 3:
                return <BusinessName />;
            case 4:
                return <BusinessDescription />;
            case 5:
                return <AboutBusiness />;
            default:
                return <OtpVerification />;
        }

    }

    const getTitle = () => {
        // if (page === 2) {
        //     return (formData.registeredBusiness || sessionBusinessType) === "business" ? data[2].businessTitle : data[2].freelancerTitle;
        // }
        return data[page]?.title;
    }

    const getContent = () => {
        // if (page === 2) {
        //     return (formData.registeredBusiness || sessionBusinessType) === "business" ? data[2].businessContent : data[2].freelancerContent;
        // }
        return data[page]?.content;
    }

    // browser back button handling 

    // useEffect(() => {
    //     // Custom back button handler
    //     const handleBackButton = (event) => {
    //         event.preventDefault(); // Prevent the default back button behavior

    //         // Update the page state
    //         setPage((prev) => {
    //             const newPage = prev - 1;
    //             return newPage;
    //         });

    //         // Push a new state to history so that future back events can be tracked
    //         window.history.pushState(null, '', window.location.href);
    //     };

    //     // Push the initial custom state to history
    //     window.history.pushState(null, '', window.location.href);

    //     // Attach the popstate event listener
    //     window.addEventListener('popstate', handleBackButton);

    //     return () => {
    //         // Clean up event listener on component unmount
    //         window.removeEventListener('popstate', handleBackButton);
    //     };
    // }, []);

    // useEffect(() => {
    //     // dispatch(businessInfo())

    //     const disableBackButton = () => {
    //         window.history.pushState(null, '', window.location.href);
    //         window.onpopstate = function (event) {
    //             window.history.go(1);  // Corrected this line
    //         };
    //     };

    //     disableBackButton();

    //     return () => {
    //         window.onpopstate = null;  // Cleanup when component unmounts
    //     };
    // }, []);

    const profileCompletion = useSelector((state) => state?.BusinessInfoReducer?.businessInfo?.profile_completion)
    useEffect(() => {
        if (profileCompletion === 6) {
            navigate('/dashboard')
        }
    }, [profileCompletion])
    // back button 

    useEffect(() => {
        let businessType = formData.registeredBusiness;
        if (page > 0) {
            sessionStorage.setItem('currentPage', '');
            sessionStorage.setItem('currentPage', page);
            if (businessType) {
                sessionStorage.setItem('businessType', businessType)
            }
        }
        const handleBackButton = (event) => {
            event.preventDefault(); // Prevent default back navigation
            let current = window.location.href;

            // if (page > 3) {
            //     setPage(prevPage => prevPage - 1);
            // } else {
            //     current = '/login';
            // }
            if (page === 0) {
                window.location.href = '/login';
            } else {
                setUnsavedProgressModal(true)
            }
        };

        // Listen to popstate event
        window.onpopstate = handleBackButton;

        // Push initial state
        window.history.pushState(0, ''); // Store current page in state

        return () => {
            window.onpopstate = null; // Cleanup
        };


    }, [page]);


    // reload button clicked
    useEffect(() => {
        const fromLoginPage = sessionStorage.getItem('fromLoginPage');
        const currentPage = sessionStorage.getItem('currentPage');
        if (fromLoginPage) {
            sessionStorage.removeItem('fromLoginPage'); // Clean up flag
        } else {
            if (!localStorage.accessToken) {
                window.location.href = '/login';
            }
            else {

                setPage(parseInt(currentPage))

                // setOtpVerified(true)
                dispatch(businessInfo())
            }
        }

    }, [navigate]);

    const isHttps = (url) => url.startsWith('https');

    useEffect(() => {
        if (resentOtpTriggered) {
            setTimeout(() => {
                setRecentOtpTriggered(false);
            }, 5000)
        }
    }, [resentOtpTriggered])

    return (
        <>
            <figure className="bg_wrapper">
                <img src="" alt="" />
            </figure>
            <StyleWrapper>
                <Row justify="center" align="middle" style={{ minHeight: '100vh' }}>
                    <Col xs={22} lg={14} >
                        <Card style={{ width: "100%" }} className='parent_radius multi_step_form'>
                            {/* prev button */}

                            {page !== 1 && (
                                <Button htmlType="submit" type='dashed' className='prev_button border_unset' style={{ width: "auto", background: "transparent", boxShadow: 'unset', marginTop: "calc(2vw + 20px)", marginLeft: "calc(1vw + 20px)" }}
                                    onClick={(e) => {
                                        setResetForm(true)
                                        e.preventDefault();

                                        if (page === 1) {
                                            setUnsavedProgressModal(true);
                                        } else if (page === 0) {
                                            window.location.href = '/login';
                                        } else {
                                            setPage(page - 1);
                                        }
                                        setFormData({
                                            otp: "",
                                            registeredBusiness: "",
                                            panNumber: "",
                                            gstin: "",
                                            businessCategories: [],
                                            otherCategories: "",
                                            businessName: "",
                                            logoUrl: "",
                                            businessDescription: "",
                                            businessAddress: '',
                                            contactNumber: "",
                                            pincode: "",
                                            state: {
                                                "code": "KL",
                                                "label": "Kerala"
                                            }
                                        })
                                        return false;
                                    }}

                                >
                                    <img src={prevButton} alt="" />
                                </Button>
                            )


                            }
                            <div className="progress">
                                <span style={{ width: `${((page + 1) * progress)}%` }}></span>
                            </div>
                            <Row gutter={[16, 24]} className='form_wrap ' style={{ flexDirection: "column" }}>
                                <div className="multistep_form_content">
                                    <div className="text-center" style={{ margin: "20px 0" }}>
                                        <h2 className='text_lg' style={{ color: customStyles.colorPrimary }}>{getTitle()}</h2>
                                        <p className='sm2'>{getContent()}</p>
                                    </div>
                                    <div>
                                        <MultiStepFormData.Provider value={{ formData, setFormData, formVerified, setFormVerified, page, reset: resetForm, setReset: setResetForm, skipButtonVisible, setSkipButtonVisible }} >
                                            {FormData()}
                                        </MultiStepFormData.Provider>
                                    </div>
                                </div>
                                {
                                    loading && (
                                        <div className="spinner sm center ">
                                            <Spin />
                                        </div>
                                    )
                                }
                                <div className='text-center button_holder'>
                                    <Button htmlType="submit" type='primary'
                                        className='md'
                                        disabled={formVerified[page] ? false : true && loading ? false : true}
                                        onClick={(e) => {

                                            if (formData.otp.length == 6 && !formData.registeredBusiness && page == 0) {
                                                verifyOtp(formData.otp)
                                            }

                                            if (formData.registeredBusiness && page == 1) {
                                                updateBusinessInfo({ business_type: formData.registeredBusiness, profile_completion: page }, 2)
                                            }

                                            // if (formData.gstin && page == 2) {
                                            //     if (getGstDetailsFlag) {
                                            //         setLoading(true)
                                            //         let id_number = formData.gstin;
                                            //         const getGstiDetails = async () => {
                                            //             try {
                                            //                 const endPoint = '/get/my-gst';
                                            //                 const result = await fetchData(endPoint, { "id_number": id_number });
                                            //                 if (result?.address) {
                                            //                     setLoading(false)
                                            //                     setGstDataModal(true)
                                            //                     setGstResponseDetails({
                                            //                         loading: false,
                                            //                         address: result?.address || '',
                                            //                         business_name: result?.business_name || '',
                                            //                         status: result?.gstin_status || ''
                                            //                     });
                                            //                 }
                                            //             } catch (error) {
                                            //                 setLoading(false)
                                            //                 console.error('Error fetching data:', error);
                                            //             }
                                            //         };
                                            //         getGstiDetails();
                                            //         getGstDetailsFlag = false;
                                            //     }
                                            // }
                                            // if (formData.panNumber && page == 2) {
                                            //     verifyPan(formData.panNumber);
                                            // }
                                            if (formData.businessCategories && page == 2) {
                                                updateBusinessInfo({ business_category: formData.businessCategories, profile_completion: page }, 3)
                                            }
                                            if (formData.otherCategories && page == 2) {
                                                updateBusinessInfo({ business_category: formData.otherCategories, profile_completion: page }, 3)
                                            }
                                            Log('page', 'info', page)
                                            if (formData.businessName && page == 3) {
                                                dispatch(businessInfo())
                                                updateBusinessInfo({ business_name: formData.businessName, profile_completion: page }, 4)
                                            }
                                            if ((formData.businessDescription || formData.logoUrl) && page == 4) {
                                                let imageUrl = isHttps(formData.logoUrl)
                                                if (!imageUrl) {
                                                    dispatch(businessInfo())
                                                    updateBusinessInfo({ business_description: formData.businessDescription, file: formData.logoUrl, profile_completion: page }, 5)
                                                }
                                                else {
                                                    dispatch(businessInfo())
                                                    updateBusinessInfo({ business_description: formData.businessDescription }, 5)
                                                }
                                                // dispatch(businessInfo())
                                                // updateBusinessInfo({ business_description: formData.businessDescription, file: formData.logoUrl, profile_completion: page }, 6)
                                            }

                                            if (formData.businessAddress && page == 5) {
                                                updateBusinessInfo({
                                                    business_address: formData.businessAddress,
                                                    contact_number: formData.contactNumber,
                                                    pincode: formData.pincode,
                                                    state: formData.state,
                                                    profile_completion: page
                                                }, 7)
                                            }

                                            else {
                                                e.preventDefault();
                                                return false;
                                            }


                                        }}
                                        style={{ width: "100%", maxWidth: "calc(200px + 6.5vw)", marginLeft: "auto", marginRight: "auto", marginTop: "0", height: "auto" }}>
                                        {" "}  {page === pageLength - 1 ? "Continue" : "Continue"}
                                    </Button>
                                    {
                                        ((page === 4 || page === 5) && skipButtonVisible) && <Button type='primary' className='grey md btn_sm skip_button' onClick={() => {
                                            setPage((prev) => prev + 1)
                                            setFormData({
                                                otp: "",
                                                registeredBusiness: "",
                                                panNumber: "",
                                                gstin: "",
                                                businessCategories: [],
                                                otherCategories: "",
                                                businessName: "",
                                                logoUrl: "",
                                                businessDescription: "",
                                                businessAddress: '',
                                                contactNumber: "",
                                                pincode: "",
                                                state: {
                                                    "code": "KL",
                                                    "label": "Kerala"
                                                }
                                            })
                                            updateBusinessInfo({ profile_completion: page })
                                            if (page === 5) {
                                                navigate('/dashboard');
                                            }
                                        }}><span>Skip</span></Button>
                                    }
                                </div>
                            </Row>
                        </Card>
                    </Col>
                </Row>
                <Modal className='sm_modal work_modal center_modal gst_details' afterClose={() => (document.body.style.overflow = 'initial')} onCancel={() => {
                    setGstDataModal(false)
                }} open={gstDataModal} footer={[
                    <div className='text-center'>
                        <Button key="close" type="text" className="short custom_btn" onClick={() => {
                            setGstDataModal(false)
                        }}>
                            Close
                        </Button>

                        <Button key="submit" type="primary" className='short wide' disabled={gstResponseDetails?.status === 'Active' ? false : true} onClick={() => {
                            setLoading(true)
                            verifyGst({ id_number: formData.gstin, profile_completion: page })
                        }}>
                            Confirm
                        </Button>
                    </div>,
                ]} onCancel={() => {
                    setGstDataModal(false);
                }}>
                    <h2 className='text_md2 text_red text-center text_lg'>GST Details</h2>
                    <div className="gst_cnt" >
                        <div className="cnt">
                            <h2 className='text_md'>Business Name </h2>
                            <p className='text_red md'>{gstResponseDetails?.business_name} </p>
                        </div>
                        <div className="cnt">
                            <h2 className='text_md'>Address</h2>
                            <p className='text_red md'>{gstResponseDetails?.address} </p>
                        </div>
                        <div className="cnt">
                            <h2 className="text_md">Status</h2>
                            {/* temp */}
                            <p className='text_red md mb-0'>{gstResponseDetails?.status} </p>

                        </div>
                    </div>
                </Modal>
                <Modal
                    className='sm_modal work_modal center_modal'
                    open={unsavedProgressModal}
                    closable={false}
                    footer={[
                        <div className='text-center'>
                            <Button
                                key="stay"
                                type="primary"
                                className='short wide'
                                onClick={() => {
                                    window.location.href = '/login';  // Stay on Page
                                }}>
                                Continue
                            </Button>

                            <Button key="close" type="text" className="short custom_btn" onClick={() => {
                                setUnsavedProgressModal(false)
                            }}>
                                Close
                            </Button>
                        </div>
                    ]}
                    onCancel={() => {
                        setUnsavedProgressModal(false);  // Close modal
                    }}
                >
                    <div className="modal_cnt">
                        <h2 className="text_lg text_red">{popupData?.content?.title}</h2>
                        <p className="md">
                            {popupData?.content?.description}
                        </p>
                    </div>
                </Modal>
                {/* <Modal
                    className='sm_modal work_modal'
                    open={loginPageRedirection}
                    closable={false}
                    footer={[
                        <Button
                            key="stay"
                            type="default"
                            className='short sm'
                            onClick={() => {
                                setUnsavedProgressModal(false);  // Stay on Page
                            }}>
                            Stay on Page
                        </Button>,
                        <Button
                            key="go-back"
                            type="primary"
                            className='short sm'
                            onClick={() => {
                                window.location.href = '/login';  // Go Back
                            }}>
                            Go Back
                        </Button>,
                    ]}
                    onCancel={() => {
                        setUnsavedProgressModal(false);  // Close modal
                    }}
                >
                    To continue filling out the form, click Stay on Page
                </Modal> */}
                <NeedHelp />
                {/* <Modal footer={null} className='sm_modal work_modal' open={errorModal.status} onOk={handleCancel} onCancel={handleCancel}>
                    {errorModal.message}
                </Modal> */}
            </StyleWrapper>

        </>
    )
}

export default MultiStepForm
export {
    MultiStepFormData
}
